import { Box, Button, Collapse, Grid, IconButton, Typography, } from "@material-ui/core";
import { Translate as T } from "react-localize-redux";
import React, { useState } from "react";
import { useCheckoutContext } from "../../../context/useCheckoutContext";
import { makeStyles } from "@material-ui/core/styles";
import Alert from "@material-ui/lab/Alert";
import CloseIcon from "@material-ui/icons/Close";
var useStyles = makeStyles(function (theme) { return ({
    button: {
        background: "rgba(2, 51, 101, 0.1)",
        borderRadius: "0 " + theme.spacing(1) + "px 0 0",
        fontSize: "12px",
        minHeight: theme.spacing(8),
        padding: theme.spacing(2, 3),
        textAlign: "inherit",
    },
    img: {
        "& path": {
            fill: theme.typography.subtitle1.color,
        },
        fill: theme.typography.subtitle1.color,
        marginRight: theme.spacing(1),
        maxWidth: theme.spacing(3),
        verticalAlign: "middle",
    },
    modal: {
        background: "#FFFFFF",
        borderRadius: "8px",
        boxShadow: "0px 7px 14px rgba(60, 66, 87, 0.12), 0px 3px 6px rgba(0, 0, 0, 0.12)",
        left: "12px",
        position: "absolute",
        right: "12px",
        width: "auto",
    },
    textModal: {
        color: "#000000",
        fontFamily: "IBM Plex Sans",
        fontSize: "12px",
    },
    title: {
        alignItems: "center",
        color: theme.typography.subtitle1.color,
        display: "flex",
        fontSize: "14px",
        marginLeft: theme.spacing(3),
    },
}); });
export var ConfrontaHeader = function () {
    var _a = useCheckoutContext().checkoutSection.header, title = _a.title, TitleImg = _a.titleImg;
    var classes = useStyles();
    var _b = useState(false), openModal = _b[0], setOpenModal = _b[1];
    return (React.createElement(React.Fragment, null,
        React.createElement(Box, { display: "flex", justifyContent: "space-between", alignItems: "center" },
            React.createElement(Typography, { className: classes.title },
                TitleImg && (React.createElement("span", null,
                    React.createElement(TitleImg, { className: classes.img }))),
                React.createElement(T, { id: title })),
            React.createElement(Button, { className: classes.button, onClick: function () {
                    setOpenModal(true);
                } },
                React.createElement(T, { id: "howtoWorksButton" }))),
        React.createElement(Grid, { item: true, xs: 12 },
            React.createElement(Box, { padding: 0.5, paddingLeft: 2, paddingRight: 2, alignItems: "center", flexDirection: "row" },
                React.createElement(Collapse, { in: openModal },
                    React.createElement(Alert, { icon: false, className: classes.modal, action: React.createElement(IconButton, { "aria-label": "close", size: "small", onClick: function () {
                                setOpenModal(false);
                            } },
                            React.createElement(CloseIcon, null)) },
                        React.createElement(Typography, { className: classes.textModal },
                            React.createElement(T, { id: "confrontaAuthentication.confrontaInformation" }))))))));
};
export default ConfrontaHeader;
